<template>
  <div>
    <div class="partners-barchart-buttons">
      <div
        v-for="(chart, index) in charts"
        :key="index"
        class="partners-barchart-button"
        :class="{'partners-barchart-button--selected': currentChartIndex == index}"
        @click="currentChartIndex = index"
      >
        <fa-icon
          icon="square"
          class="mr-2"
          :style="{color: color(chart.title)}"
        />
        <span>{{ chart.title }}</span>
      </div>
    </div>
    <BarChart
      :height="300"
      :chart-data="currentChart"
      :options="options"
    />
  </div>
</template>

<script>
// import _ from 'lodash';
import BarChart from './BarChart.vue';
import { studentsService } from '../../_services';
import CONFIG from '../../config';

export default {
    name: 'PartnersBarChart',
    components: {
        BarChart,
    },
    props: {
        careerUuid: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            labels: [],
            charts: [],
            currentChartIndex: 0,
        };
    },
    computed: {
        currentChart() {
            if (this.charts[this.currentChartIndex]) {
                return this.charts[this.currentChartIndex];
            }

            return {};
        },
    },
    mounted() {
        this.fetchData();
    },
    // watch: {
    //     data: {
    //         deep: true,
    //         handler() {
    //             this.renderChart(this.data, this.options);
    //         }
    //     }
    // },
    methods: {
        color(title) {
            return CONFIG.COLORS.partners[title];
        },
        fetchData() {
            studentsService
                .careerGradesData(
                    this.$store.getters['authentication/student_uuid'],
                    this.careerUuid,
                )
                .then((response) => {
                    const formatter = new Intl.NumberFormat('es-Es', { maximumSignificantDigits: 3 });

                    response.data.forEach((i) => {
                        const grades = i.hist_grades_pdf.map((pdf, index) => ({
                            label: i.bin_edges[index + 1] - 1.5,
                            value: pdf[1],
                            student: i.student_index - 1 === index,
                        }));

                        // grades.push({
                        //     label: i.student_grade,
                        //     value: (i.hist_grades_pdf[i.student_index+1]),
                        //     student: true,
                        // });

                        const ordered = grades
                            .sort((a, b) => a.label - b.label);

                        const colors = new Array(11).fill(CONFIG.COLORS.partners[i.name]);

                        const labels = ordered.map((item, index) => {
                            if (item.student) {
                                colors[index] = '#cccccc';
                                return 'Mi puntaje';
                            }
                            return formatter.format(item.label);
                        });

                        this.charts.push({
                            title: i.name,
                            labels,
                            datasets: [
                                {
                                    label: i.name,
                                    backgroundColor: colors,
                                    borderColor: colors,
                                    data: ordered.map(item => item.value),
                                },
                            ],
                        });
                    });
                })
                .catch(() => {
                    // Handle error here
                });
        },
    },
};
</script>
<style lang="scss">
.partners-barchart-buttons {
    margin-bottom: 1rem;
}
.partners-barchart-button {
    margin-right: 1rem;
    cursor: pointer;
    text-align: left;
    @media only screen and (min-width: 600px) {
        display: inline-block;
    }

    span {
        opacity: 0.3;
        transition: all 0.2s;
    }
}
.partners-barchart-button--selected {
    span {
        opacity: 1;
    }
}
</style>
